import { createAction, props } from "@ngrx/store";

export const AuthActions = {
    login: createAction(
        "[Auth] Login",
        props<{ redirect?: string | undefined; connection?: string | undefined; email?: string | undefined }>(),
    ),
    logout: createAction("[Auth] Logout"),
};
